import { Button, Container, CopyText, Flex, Grid } from '@dtpk-cc/components';
import { CheckAvailabilityInput } from 'gql/__generated/vp-apollo';
import { ControlledInput } from 'components/form/ControlledInput';
import { RouterTextLink } from 'components/content/RouterTextLink';
import { useAddressSearchFormContext } from '../hooks/useAddressSearchForm';
import './AddressSearchForm.scss';

export interface AddressSearchFormProps {
    submit: (address: CheckAvailabilityInput) => void;
    goBackPath?: string;
}

export const AddressSearchForm = ({ submit, goBackPath }: AddressSearchFormProps) => {
    const { handleSubmit, lockSubmission } = useAddressSearchFormContext();

    return (
        <form onSubmit={handleSubmit(submit)} autoComplete="off" noValidate>
            <Container variants={Container.Variant.paddedTop}>
                <Grid>
                    <Grid.Row gutter>
                        <Grid.Col s={6} m={9} l={9} xl={18} marginBottom>
                            <ControlledInput id="street" name="street" data-test-section="input-street" autoFocus>
                                Straße*
                            </ControlledInput>
                        </Grid.Col>
                        <Grid.Col s={6} m={3} l={3} xl={6} marginBottom>
                            <ControlledInput
                                id="house-number"
                                name="houseNumber"
                                data-test-section="input-house-number"
                            >
                                Hausnr.*
                            </ControlledInput>
                        </Grid.Col>
                    </Grid.Row>
                    <Grid.Row gutter>
                        <Grid.Col s={6} m={3} l={3} xl={6} marginBottom>
                            <ControlledInput
                                id="zip"
                                name="zip"
                                data-test-section="input-zip"
                                mask={{
                                    mask: '99999',
                                    char: '',
                                }}
                            >
                                PLZ*
                            </ControlledInput>
                        </Grid.Col>
                        <Grid.Col s={6} m={9} l={9} xl={18} marginBottom>
                            <ControlledInput id="city" name="city" data-test-section="input-city">
                                Ort*
                            </ControlledInput>
                        </Grid.Col>
                    </Grid.Row>
                </Grid>
                <CopyText variants={CopyText.Variant.additional}>
                    * Die gekennzeichneten Felder sind Pflichtangaben.
                </CopyText>
            </Container>
            <Container variants={Container.Variant.paddedTop}>
                <Flex
                    wrap
                    gap
                    alignContent="center"
                    alignItems="center"
                    flexDirection="column"
                    customClass={goBackPath ? 'with-back-link' : 'without-back-link'}
                >
                    <Button
                        type="submit"
                        id="send-address-form-btn"
                        data-test-action="send-address-button"
                        disabled={lockSubmission}
                    >
                        {lockSubmission ? 'Bitte warten...' : 'Verfügbarkeit prüfen'}
                    </Button>

                    {!!goBackPath && (
                        <RouterTextLink data-test-action="goto-to-customer-type-selection" to={goBackPath} replace>
                            Zurück zur Vertragsauswahl
                        </RouterTextLink>
                    )}
                </Flex>
            </Container>
        </form>
    );
};
